import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import './Tarot.css';

const excludedIds = [34, 35, 36, 48, 49, 50, 62, 63, 64, 76, 77, 78];

// Correspondance entre chaque carte (majeure ou mineure) et son groupe d'interprétation
const cardToGroup = {
  1: 1, 23: 1, 37: 1,
  2: 2, 24: 2, 38: 2,
  3: 3, 25: 3, 39: 3,
  4: 4, 26: 4, 40: 4,
  5: 5, 27: 5, 41: 5,
  6: 6, 28: 6, 42: 6,
  7: 7, 29: 7, 43: 7,
  8: 8, 30: 8, 44: 8,
  9: 9, 31: 9, 45: 9,
  10: 10, 32: 10, 46: 10,
  11: 11, 33: 11, 47: 11,
  12: 12, 65: 12, 51: 12,
  13: 13, 66: 13, 52: 13,
  14: 14, 67: 14, 53: 14,
  15: 15, 68: 15, 54: 15,
  16: 16, 69: 16, 55: 16,
  17: 17, 70: 17, 56: 17,
  18: 18, 71: 18, 57: 18,
  19: 19, 72: 19, 58: 19,
  20: 20, 73: 20, 59: 20,
  21: 21, 74: 21, 60: 21,
  22: 22, 75: 22, 61: 22
};

const interpretationTable = {
  1: ["Futur, évènement rapide", "Un nouveau projet", "Un enfant"],
  2: ["Dans longtemps", "Des problèmes cachés (Maladie souvent)", "Personne religieuse"],
  3: ["Avant le calme", "Dépassé des limites", "Personne appréciée"],
  4: ["Avant/Après une sécurité", "Évènement violent", "Un homme"],
  5: ["Stable", "Un évènement inattendu (surprenant)", "Un enseignant"],
  6: ["Présent", "Une décision à prendre avec des conséquences", "Un séducteur"],
  7: ["Durant un voyage", "Un voyage", "Un leader"],
  8: ["Il y a peu", "Une sanction", "Représentant légal / mage de loi"],
  9: ["Dans très longtemps", "Projet compromis", "Un aîné (âgé)"],
  10: ["Inconnu", "Une opportunité", "Ami/allié potentiel"],
  11: ["Après un conflit", "Une alliance", "Une personne remarquable physiquement"],
  12: ["Stagne", "Perdre quelque chose", "Un bandit / voleur, etc."],
  13: ["Il y a longtemps", "Transformation", "Ténèbre"],
  14: ["Présent", "Établir un lien", "Un entremetteur"],
  15: ["Futur proche", "Secret révélé", "Un amant"],
  16: ["Passé lointain", "Un bouleversement", "Un chercheur"],
  17: ["Passé", "Guérison", "Un artiste"],
  18: ["La nuit", "Mensonge", "Un proche"],
  19: ["Le jour", "Conflit avec une autorité", "Un noble"],
  20: ["Le matin", "Un renouvellement", "Force de l'ordre"],
  21: ["Une fin", "Une réussite", "Une femme"],
  22: ["Futur", "Se perdre", "Un inconnu"]
};

export default function Tarot() {
  const [tarotDeck, setTarotDeck] = useState([]);
  const [selectedCards, setSelectedCards] = useState([]);
  const [disabledCardIds, setDisabledCardIds] = useState([]);

  useEffect(() => {
    fetch('/cartes/cartes.csv')
      .then((response) => response.text())
      .then((csvText) => {
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const rawCards = results.data;
            const filteredCards = rawCards
              .map((row) => ({
                id: parseInt(row.chiffre, 10),
                name: row.nom,
                image: `/cartes/${row.chiffre}.jpg`,
              }))
              .filter((card) => !excludedIds.includes(card.id));

            setTarotDeck(filteredCards);
          },
        });
      });
  }, []);

  const handleCardClick = (card) => {
    if (selectedCards.length >= 3 || disabledCardIds.includes(card.id)) return;
    setSelectedCards([...selectedCards, card]);
    setDisabledCardIds([...disabledCardIds, card.id]);
  };

  const handleSelectedCardClick = (card) => {
    const updatedSelectedCards = selectedCards.filter((c) => c.id !== card.id);
    const updatedDisabledIds = disabledCardIds.filter((id) => id !== card.id);
    setSelectedCards(updatedSelectedCards);
    setDisabledCardIds(updatedDisabledIds);
  };

  const showResult = () => {
    const result = selectedCards.map((card, index) => {
      const group = cardToGroup[card.id];
      const interpretation = interpretationTable[group];
      return interpretation
        ? `Carte ${index + 1} - ${card.name} : ${interpretation[index]}`
        : `Carte ${index + 1} - ${card.name} : Interprétation non trouvée.`;
    }).join('\n');

    alert(result);
  };

  return (
    <div className="tarot-app">
      <div className="header-controls">
        <button 
          className="see-result-button"
          disabled={selectedCards.length !== 3}
          onClick={showResult}
        >
          Voir le tirage
        </button>
      </div>

      <div className="selected-cards">
        {[0, 1, 2].map((i) => (
          <div key={i} className="card-slot">
            {selectedCards[i] ? (
              <img
                src={selectedCards[i].image}
                alt={selectedCards[i].name}
                className="card-img"
                onClick={() => handleSelectedCardClick(selectedCards[i])}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <div className="card-placeholder">Slot {i + 1}</div>
            )}
          </div>
        ))}
      </div>

      <div className="card-grid">
        {tarotDeck.map((card) => (
          <button
            key={card.id}
            className={`card-button ${disabledCardIds.includes(card.id) ? 'disabled' : ''}`}
            onClick={() => handleCardClick(card)}
            disabled={disabledCardIds.includes(card.id)}
          >
            <img src={card.image} alt={card.name} className="card-img" />
            <span className="card-name">{card.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
